import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { identity } from '@antv/util';
import { Continuous } from './continuous';
import { createInterpolateValue } from '../utils';
import { d3Ticks } from '../tick-methods/d3-ticks';
/**
 * Linear 比例尺
 *
 * 构造可创建一个在输入和输出之间具有线性关系的比例尺
 */
export var Linear = /*#__PURE__*/function (_Continuous) {
  _inherits(Linear, _Continuous);
  function Linear() {
    _classCallCheck(this, Linear);
    return _possibleConstructorReturn(this, _getPrototypeOf(Linear).apply(this, arguments));
  }
  _createClass(Linear, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0, 1],
        unknown: undefined,
        nice: false,
        clamp: false,
        round: false,
        interpolate: createInterpolateValue,
        tickMethod: d3Ticks,
        tickCount: 5
      };
    }
  }, {
    key: "chooseTransforms",
    value: function chooseTransforms() {
      return [identity, identity];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Linear(this.options);
    }
  }]);
  return Linear;
}(Continuous);